<div class="sidebar">
    <div class="sidebar-widget">
      <form method="post">
        <h5>Search Posts</h5>
        <input type="text" class="form-control" placeholder="Search" name="sidebar-search" value="">
      </form>
    </div>
    <div class="sidebar-widget">
      <h5>Recent Posts</h5>
      <article class="media">
        <a routerLink='/blog-single'><img src="assets/img/blog-sm/1.jpg" alt="post"></a>
        <div class="media-body">
          <h6> <a routerLink='/blog-single'>Cheese wheels can be the next thing</a> </h6>
          <span>January 22, 2020</span>
        </div>
      </article>
      <article class="media">
        <a routerLink='/blog-single'><img src="assets/img/blog-sm/2.jpg" alt="post"></a>
        <div class="media-body">
          <h6> <a routerLink='/blog-single'>Our all new chicken pizza now available</a> </h6>
          <span>January 24, 2020</span>
        </div>
      </article>
      <article class="media">
        <a routerLink='/blog-single'><img src="assets/img/blog-sm/3.jpg" alt="post"></a>
        <div class="media-body">
          <h6> <a routerLink='/blog-single'>Rose flavored pizza is going crazy nowdays</a> </h6>
          <span>January 26, 2020</span>
        </div>
      </article>
      <article class="media">
        <a routerLink='/blog-single'><img src="assets/img/blog-sm/4.jpg" alt="post"></a>
        <div class="media-body">
          <h6> <a routerLink='/blog-single'>Career offerings now open, sign up today</a> </h6>
          <span>January 28, 2020</span>
        </div>
      </article>
    </div>

    <div class="sidebar-widget tags">
      <h5>Popular Tags</h5>
      <a routerLink='/blog-single'>Food</a>
      <a routerLink='/blog-single'>Foodie</a>
      <a routerLink='/blog-single'>Chicken</a>
      <a routerLink='/blog-single'>Meat</a>
      <a routerLink='/blog-single'>Health</a>
      <a routerLink='/blog-single'>Vegan</a>
      <a routerLink='/blog-single'>Fit</a>
      <a routerLink='/blog-single'>Fruit</a>
    </div>

  </div>